<template>
  <v-dialog v-model="dialogStatus"
            persistent
            max-width="800px">
    <div class="fill-height">


      <v-card class="fill-height">

        <v-card-subtitle>تعریف گروه تخفیفات</v-card-subtitle>
<v-spacer/>
        <v-card-text>


          <v-form  ref="form" @submit.prevent="save" lazy-validation v-model="valid">
            <v-row>

              <v-col
                  cols="12"
                  sm="6"
                  md="4">

                <v-text-field
                    label="نام گروه اصلی"
                    outlined
                    dense
                    :error-messages="getError('nameGroup')"
                    v-model="model.nameGroup"
                />

              </v-col>
            </v-row>
            <v-row>

<!--              <v-col-->
<!--                  cols="12"-->
<!--                  sm="6"-->
<!--                  md="4">-->

<!--                <v-text-field-->
<!--                    label="نام گروه فرعی"-->
<!--                    outlined-->
<!--                    dense-->
<!--                    :error-messages="getError('name')"-->
<!--                    v-model="nameSub"-->
<!--                />-->

<!--              </v-col>-->
<!--              <v-col-->
<!--                  cols="12"-->
<!--                  sm="6"-->
<!--                  md="4">-->

<!--                <v-btn-->
<!--                    label="اضافه کردن"-->
<!--                    @click="add"-->
<!--                    outlined-->
<!--                    depressed-->
<!--                />-->

<!--              </v-col>-->
              <v-col
                  cols="12"
                  sm="12"
                  md="12">

                <v-data-table
                    hide-default-footer
                    :headers="headers"
                    :items="model.subGroupList"
                    class="elevation-1"
                >

                  <template v-slot:top>
                    <v-toolbar
                        flat
                    >

                      <v-spacer></v-spacer>
                      <v-dialog
                          v-model="dialog"
                          max-width="500px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              color="success"
                              dark
                              depressed
                              class="mb-2"
                              v-bind="attrs"
                              v-on="on"
                          >
                          اضافه کردن گروه فرعی
                          </v-btn>
                        </template>
                        <v-card>
                          <v-card-title>
                            <span> اضافه کردن گروه فرعی</span>
                          </v-card-title>

                          <v-card-text>
                            <v-container>
                              <v-row>

                                <v-col
                                    cols="12"
                                    md="6">
                                  <v-text-field
                                      outlined
                                      dense
                                      v-model="editedItem.nameSub"
                                      label="نام"
                                  ></v-text-field>
                                </v-col>

                              </v-row>
                            </v-container>
                          </v-card-text>

                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="error"
                                depressed
                                @click="close"
                            >
                              لغو
                            </v-btn>
                            <v-btn
                                color="primary"
                                depressed
                                @click="saveItem"
                            >
                              ثبت
                            </v-btn>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                      <v-dialog v-model="dialogDelete" max-width="500px">
                        <v-card>
                          <v-card-title> از حذف این رکورد مطمئن هستید؟</v-card-title>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="primary" depressed @click="closeDelete">لغو</v-btn>
                            <v-btn color="error" depressed @click="deleteItemConfirm">تایید</v-btn>
                            <v-spacer></v-spacer>
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </v-toolbar>
                  </template>
                  <template v-slot:item.actions="{ item }">

                    <v-btn icon
                           small
                           @click="deleteItem(item)"
                    >
                      <v-icon>
                        mdi-delete
                      </v-icon>

                    </v-btn>
                  </template>

                </v-data-table>

              </v-col>
            </v-row>


            <v-divider class="p-0 m-0"/>
            <v-card-actions dir="ltr">

              <v-btn
                 small
                 depressed
                  color="primary"
                  class=" pr-1 pl-1"
                  type="submit"
                 :loading="loading"
              >
                ذخیره
              </v-btn>
              <v-btn
                  small
                  depressed
                  color="error"
                  class=" p-1 m-1"
                  @click="closed"
              >
                لغو
              </v-btn>
            </v-card-actions>
          </v-form>
        </v-card-text>
      </v-card>
    </div>
  </v-dialog>
</template>

<script>
import MainGroup_se from "./MainGroup_se";



export default {

  props: {
    dialogStatus: {
      default: false,
    },
    model: Object,
  },
  data() {
    return {
      headers: [
        {
          text: 'نام گروه فرعی',
          value: 'nameSub',
        },
        {text: 'عملیات', value: 'actions'},
      ],

      bindingErrors: [],
      loading: false,
      dialog: false,
      dialogDelete: false,
      valid: true,
      defaultItem: {
        nameSub: '',
      },
      editedItem: {
        nameSub:'',
        codeSub:0
      },


    }
  },




  methods: {

    getError(key) {
      if (this.bindingErrors && this.bindingErrors.length > 0) {
        let error = this.bindingErrors.find(({fieldName}) => fieldName === key);
        if (error && error.message) return error.message[0]
      }
      return ''
    },

    deleteItem(item) {
      this.editedIndex = this.model.subGroupList.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialogDelete = true
    },

    deleteItemConfirm() {
      this.model.subGroupList.splice(this.editedIndex, 1)
      this.closeDelete()
    },

    close() {
      this.dialog = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    closeDelete() {
      this.dialogDelete = false
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      })
    },

    saveItem() {
      if (this.editedIndex > -1) {
        Object.assign(this.model.subGroupList[this.editedIndex], this.editedItem)
      } else {
        this.model.subGroupList.push(this.editedItem)
      }
      this.close()
    },


    closed() {
      this.bindingErrors=[]
      this.loading=false
      this.$emit('update:dialogStatus', false)
      this.$root.$emit('MainGroup' )


    },


    save() {
      this.loading=true
      this.bindingErrors = []
      this.$progress({message: 'درحال ثبت ...'}, true)
      MainGroup_se.save(this.model).then(response => {

            if (response && response.status === 200) {
            this.$root.$emit('Progress')
            this.$snack({type: 'success'})
            this.closed()
          }else if (response && response.response.status === 400) {
            this.loading=false
            this.$root.$emit('Progress')
            this.bindingErrors = response.response.data;
          }
        })

    },

  },



}
</script>


